import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=23e203ed&scoped=true&"
import script from "./project-detail.vue?vue&type=script&lang=js&"
export * from "./project-detail.vue?vue&type=script&lang=js&"
import style0 from "./project-detail.vue?vue&type=style&index=0&id=23e203ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e203ed",
  null
  
)

export default component.exports